'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var GAMES_LOADED = 'games:loaded';
var GAMES_JACKPOTS_LIST = 'games-jackpots:list';
var GAMES_LIST = 'games:list:event';
var GAMES_LIST_QUERY = 'games:list:query';
var GAME_CMS_QUERY = 'game-cms:query';
var GAMES_LIST_CLEAR = 'games-list:clear';
var GAMES_LIST_RELOAD = 'games-list:reload';
var GAMES_PROVIDERS = 'games-providers:list';
var GAMES_SCROLL_DOWN = 'games:should-scroll-down';
var GAMES_CATEGORIES_LIST = 'games-categories:list';
var GAMES_CATEGORIES_CMS_CONTENT = 'games-categories:cms-content:query';
var GAMES_RECOMMENDED_GAMES = 'games:recommended-games';
var GAMES_RECOMMENDED_GAMES_USER = 'games:recommended-games-user';
var GAMES_FETCH = 'games:fetch';
var GAMES_SERVICE_CATEGORIES_UPDATE_NEEDED = 'games-service:categories-update-needed';
var GAMES_LOBBY_COMMAND_CHANGE = 'game-lobby:command:change';
var GAMES_SHOW_FAVOURITES_QUERY = 'games-show-favourites:query';
var GAMES_SHOW_FAVOURITES_UPDATED = 'games-show-favourites:updated';
var GAMES_IS_PLAY_FOR_FUN_QUERY = 'games-is-play-for-fun:query';
var GAMES_IS_PLAY_FOR_FUN_UPDATED = 'games-is-play-for-fun:updated';
var GAMES_SET_CURRENT_GAME_SLUG = 'games-set-current-game-slug:command';
var GAMES_CURRENT_GAME_SLUG_UPDATED = 'games-current-game-slug:event';
var GAMES_CURRENT_GAME_UPDATED = 'games-current-game:event';
var GAMES_CURRENT_GAME_POSITION_UPDATED = 'games-current-game-position:event';
var GAMES_LOBBIES_UPDATED = 'games-lobbies:event';
var GAME_COREX_FETCH_BY_ID = 'game-corex-by-id:query';
var GAMES_XFC_CURRENCY = 'games-xfc-currency:query';

exports.GAMES_CATEGORIES_CMS_CONTENT = GAMES_CATEGORIES_CMS_CONTENT;
exports.GAMES_CATEGORIES_LIST = GAMES_CATEGORIES_LIST;
exports.GAMES_CURRENT_GAME_POSITION_UPDATED = GAMES_CURRENT_GAME_POSITION_UPDATED;
exports.GAMES_CURRENT_GAME_SLUG_UPDATED = GAMES_CURRENT_GAME_SLUG_UPDATED;
exports.GAMES_CURRENT_GAME_UPDATED = GAMES_CURRENT_GAME_UPDATED;
exports.GAMES_FETCH = GAMES_FETCH;
exports.GAMES_IS_PLAY_FOR_FUN_QUERY = GAMES_IS_PLAY_FOR_FUN_QUERY;
exports.GAMES_IS_PLAY_FOR_FUN_UPDATED = GAMES_IS_PLAY_FOR_FUN_UPDATED;
exports.GAMES_JACKPOTS_LIST = GAMES_JACKPOTS_LIST;
exports.GAMES_LIST = GAMES_LIST;
exports.GAMES_LIST_CLEAR = GAMES_LIST_CLEAR;
exports.GAMES_LIST_QUERY = GAMES_LIST_QUERY;
exports.GAMES_LIST_RELOAD = GAMES_LIST_RELOAD;
exports.GAMES_LOADED = GAMES_LOADED;
exports.GAMES_LOBBIES_UPDATED = GAMES_LOBBIES_UPDATED;
exports.GAMES_LOBBY_COMMAND_CHANGE = GAMES_LOBBY_COMMAND_CHANGE;
exports.GAMES_PROVIDERS = GAMES_PROVIDERS;
exports.GAMES_RECOMMENDED_GAMES = GAMES_RECOMMENDED_GAMES;
exports.GAMES_RECOMMENDED_GAMES_USER = GAMES_RECOMMENDED_GAMES_USER;
exports.GAMES_SCROLL_DOWN = GAMES_SCROLL_DOWN;
exports.GAMES_SERVICE_CATEGORIES_UPDATE_NEEDED = GAMES_SERVICE_CATEGORIES_UPDATE_NEEDED;
exports.GAMES_SET_CURRENT_GAME_SLUG = GAMES_SET_CURRENT_GAME_SLUG;
exports.GAMES_SHOW_FAVOURITES_QUERY = GAMES_SHOW_FAVOURITES_QUERY;
exports.GAMES_SHOW_FAVOURITES_UPDATED = GAMES_SHOW_FAVOURITES_UPDATED;
exports.GAMES_XFC_CURRENCY = GAMES_XFC_CURRENCY;
exports.GAME_CMS_QUERY = GAME_CMS_QUERY;
exports.GAME_COREX_FETCH_BY_ID = GAME_COREX_FETCH_BY_ID;
